export const NA = (genre = "M") => {
  let res = "Non mentionné";
  return genre === "M" ? res : res + "e";
};

export const getAccountType = () => {
  return [
    { code: 0, label: "Consultant" },
    { code: 1, label: "Volontariat" },
    { code: 2, label: "Agex" },
    { code: 3, label: "A la fois Volontariat et Agex" },
  ];
};

export const getAccountTypeNameByCode = (code) => {
  const accountType = getAccountType();
  return accountType.at(code).label;
}; 

export const getAccountTypeByCode = (code) => {
  const accountType = getAccountType();
  return accountType.at(code);
};
